function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { connect } from "react-redux";
import Component from "../components/BonusMaterial";
import { setUIVisibilityState, fetchRating, updateRating, sendNotification } from "../actions";
import { isSlideAvailable, getNearestAvailable } from "../utils/helpers";
import store from "../store";
var mapStateToProps = function(state, _ownProps) {
    var currentSlide = state.nodes.find(function(n) {
        return n.id === state.currentSlide;
    });
    return {
        bonusMaterial: state.bonusMaterial,
        isLoading: state.loading.indexOf("fetch_bonus_material") > -1,
        visible: state.uiVisibilityState.bonusMaterial,
        currentSlideBonus: currentSlide ? state.bonusMaterial.filter(function(bm) {
            return bm.owner.id === currentSlide.target_id && bm.owner.type === currentSlide.target_type;
        }) : [],
        getSlide: function(id, type) {
            return state.nodes.find(function(n) {
                return n.target_id === id && n.target_type === type;
            });
        },
        isCompleted: function(id) {
            return state.completed.indexOf(id) > -1;
        },
        isAvailable: function(slide) {
            return isSlideAvailable(slide, state);
        },
        ratings: state.ratings,
        currentOnly: (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.allow_bonus_material) === "exam",
        session: state.session,
        socialConfig: state.socialConfig
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        close: function() {
            dispatch(setUIVisibilityState({
                state: {
                    bonusMaterial: false
                }
            }));
        },
        getRating: function(target) {
            dispatch(fetchRating({
                target: target
            }));
        },
        setRating: function(target, value) {
            dispatch(updateRating({
                target: target,
                value: value
            }));
        },
        notify: function(slide) {
            var _getNearestAvailable = _slicedToArray(getNearestAvailable(slide, store.getState()), 2), nslide = _getNearestAvailable[0], unavailablecount = _getNearestAvailable[1];
            dispatch(sendNotification({
                key: "content-not-allowed-".concat(slide.id),
                label: "ui.no_permissions",
                message: "navigation.not_allowed",
                messageProps: {
                    startId: nslide === null || nslide === void 0 ? void 0 : nslide.id,
                    multiple: unavailablecount > 1,
                    slideName: nslide === null || nslide === void 0 ? void 0 : nslide.name
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
